export function normalizeQuote(q) {
  if (!q) return q;
  if (q.descuentos && q.pago && q.proyecto) return q;

  return {
    ...q,
    cliente: q.clienteSnapshot || {},
    proyecto: {
      nombre:      q.proyectoNombre || '',
      tipo:        q.proyectoTipo || 'residencial-horizontal',
      estatus:     q.proyectoEstatus || 'preventa',
      ubicacion:   q.proyectoUbicacion || '',
      unidades:    q.proyectoUnidades || '',
      superficie:  q.proyectoSuperficie || '',
      descripcion: q.proyectoDescripcion || '',
      materiales:  q.proyectoMateriales || {},
    },
    descuentos: {
      bundle:              q.bundleAplicado || false,
      bundlePct:           Number(q.bundlePct) || 10,
      elementosPrevios:    q.elementosPrevios || false,
      elementosPreviosPct: Number(q.elementosPreviosPct) || 5,
      codigos:             [],
    },
    pago: {
      esquema:                 q.esquemaPago || '12-iguales',
      notas:                   q.notasPago || '',
      licenciaPrepagada:       q.licenciaPrepagada || false,
      licenciaPrepagadaPrecio: Number(q.licenciaPrepagadaPrecio) || 20000,
    },
    productos: (q.productos || []).map((p) => ({
      ...p,
      id:          p.productoId,
      config:      p.configSnapshot || {},
      precioFinal: Number(p.precioFinal) || 0,
    })),
  };
}